import OwnerIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/owner.svg?react';
import CustomLabel from '@/common/components/base/customLabel/CustomLabel';
import DocumentsIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/documents.svg?react';
import AdjusterIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/adjuster-icon.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import CardButton from '@/common/components/cardButton/CardButton';
import MainLayout from '@/common/components/layouts/MainLayout';
import CulpritAndroidIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/CulpritAndroidIcon.svg?react';
import VehicleInformationIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/veichel-info.svg?react';
import { getAlertInitialBodyQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getAlertInitialBody/getAlertInitialBodyQueryOptions';
import { GetInitialEntryTabsQueryResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialEntryTabs/getInitialEntryTabsQuery.type';
import { getInitialEntryTabsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialEntryTabs/getInitialEntryTabsQueryOptions';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import { INITIAL_VISIT_LINKS } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitLink';
import { useImageFlowStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/useImageFlowStore';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';

export default () => {
  return (
    <MainLayout title="بیمه گذار" header="titleHeader">
      <InitialVisitTabs />
    </MainLayout>
  );
};

const InitialVisitTabs = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { resetCameraStore } = useImageFlowStore();
  const { resetDamagedPoints } = useDamagedPoints();

  const { data: participantData } = useQuery(
    getAlertInitialBodyQueryOptions({ id: +id! }),
  );

  const { data: tabs } = useQuery(
    getInitialEntryTabsQueryOptions({ id: Number(id) }),
  );

  const renderRoute = (item: GetInitialEntryTabsQueryResponseType) => {
    let tabIcon: Record<GetInitialEntryTabsQueryResponseType['name'], string> =
      {
        owner: item.editable
          ? INITIAL_VISIT_LINKS.OWNER_INITIAL_INFO(+id!)
          : INITIAL_VISIT_LINKS.ONLY_SHOW_OWNER_INITIAL_INFO(+id!),
        vehicle_information: item.editable
          ? INITIAL_VISIT_LINKS.VEHICLE_INFO(+id!)
          : INITIAL_VISIT_LINKS.VEHICLE_INFO_SHOW(+id!),
        documents: INITIAL_VISIT_LINKS.DOCUMENTS(+id!),
        adjusting: INITIAL_VISIT_LINKS.ADJUSTER(+id!),
      };
    return tabIcon[item.name];
  };

  const renderIcon = (
    tabName: GetInitialEntryTabsQueryResponseType['name'],
  ) => {
    let tabIcon: Partial<
      Record<GetInitialEntryTabsQueryResponseType['name'], React.JSX.Element>
    > = {
      owner: <OwnerIcon />,
      vehicle_information: <VehicleInformationIcon />,
      documents: <DocumentsIcon />,
      adjusting: <AdjusterIcon />,
    };

    return tabIcon[tabName as keyof typeof tabIcon] || null;
  };
  const goToFile = (item: GetInitialEntryTabsQueryResponseType) => {
    navigate(renderRoute(item));
  };
  useEffect(() => {
    resetDamagedPoints();
    resetCameraStore();
  }, []);
  return (
    <Box pt="2rem" mx={16}>
      <Box
        className={css({
          border: '2px solid #F0EEFF',
          borderRadius: '34px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1rem',
          paddingX: '17px',
          height: '40px',
          marginX: 'auto',
          width: 'fit-content',
        })}
      >
        <CulpritAndroidIcon />
        <Box
          className={css({
            display: 'flex',
            flexDirection: 'row',
            gap: '0.25rem',
          })}
        >
          <Typography textStyle={'b1'} color="purple-1">
            {(participantData?.first_name || '') +
              ' ' +
              (participantData?.last_name || '')}
          </Typography>
        </Box>
      </Box>
      <Box
        className={css({
          borderBottom: '1px solid',
          borderColor: 'gray-2',
          my: '24px',
        })}
      ></Box>
      {tabs?.map((item) => (
        <CardButton
          key={item.name}
          cardProps={{
            className: css({ marginY: '1rem' }),
            cursor: item?.is_card_active ? 'pointer' : 'not-allowed',
            onClick: () => item.is_card_active && goToFile(item),
          }}
          hasArrow
          renderTag={() => (
            <CustomLabel
              title={item.label.fa_const}
              color={item.label.const === 'completed' ? 'green' : 'yellow'}
            />
          )}
          renderIcon={() =>
            renderIcon(
              item.name as GetInitialEntryTabsQueryResponseType['name'],
            )
          }
          title={item.fa_name}
        />
      ))}
    </Box>
  );
};
